setPmScreenErrorAction